;(function (angular) {
   'use strict'

   angular.module('azure.util').factory('youtubeUtils', function (util) {
      /**
       * Extracts YouTube video ID from various URL formats
       *
       * Supports:
       * - Standard watch URLs: https://youtube.com/watch?v=VIDEO_ID
       * - Short URLs: https://youtu.be/VIDEO_ID
       * - Embed URLs: https://youtube.com/embed/VIDEO_ID
       * - Mobile URLs: https://m.youtube.com/watch?v=VIDEO_ID
       * - Shorts URLs: https://youtube.com/shorts/VIDEO_ID
       * - Live URLs: https://youtube.com/live/VIDEO_ID
       * - NoCookie domain: https://youtube-nocookie.com/...
       *
       * @param {string} urlString - URL string that may contain a YouTube video
       * @returns {string|null} - 11-character video ID or null if not found/invalid
       */
      function extractYouTubeId(urlString) {
         if (util.isBlankString(urlString)) {
            return null
         }

         const normalizedUrl = util.normalizeRawUrl(urlString)
         if (!normalizedUrl) {
            return null
         }

         const parsedUrl = util.safeParseUrl(normalizedUrl)
         if (!parsedUrl) {
            return null
         }

         // Only allow web protocols
         const proto = (parsedUrl.protocol || '').toLowerCase()
         if (proto !== 'http:' && proto !== 'https:') {
            return null
         }

         const youtubeHostnames = {
            short: 'youtu.be',
            main: 'youtube.com',
            mobile: 'm.youtube.com',
            nocookie: 'youtube-nocookie.com',
         }

         const youtubePathPrefixes = ['shorts', 'live', 'embed', 'v']

         // Normalize hostname (remove www prefix, convert to lowercase)
         const hostname = parsedUrl.hostname.replace(/^www\./i, '').toLowerCase()

         let videoId = ''

         // Handle youtu.be short URLs
         if (hostname === youtubeHostnames.short) {
            const pathSegments = parsedUrl.pathname.split('/').filter(Boolean)
            videoId = pathSegments[0] || ''
         }
         // Handle full YouTube domain variants
         else if ([youtubeHostnames.main, youtubeHostnames.mobile, youtubeHostnames.nocookie].includes(hostname)) {
            const pathSegments = parsedUrl.pathname.split('/').filter(Boolean)

            // Standard watch URL: /watch?v=VIDEO_ID
            if (parsedUrl.pathname.startsWith('/watch')) {
               videoId = parsedUrl.searchParams.get('v') || ''
            }
            // Special path formats: /shorts/VIDEO_ID, /embed/VIDEO_ID, etc.
            else if (pathSegments.length >= 2 && youtubePathPrefixes.includes(pathSegments[0])) {
               videoId = pathSegments[1]
            }
         }

         // Validate video ID format (exactly 11 characters, alphanumeric + dash/underscore)
         return /^[A-Za-z0-9_-]{11}$/.test(videoId) ? videoId : null
      }

      //================================================================================

      return {
         extractYouTubeId: extractYouTubeId,
      }
   })
})(window.angular)
